// test42
(42 && 0);
